import React from "react";

import { css } from "@emotion/css";
import BG from "../../../img/svg/home/about-2/bg.svg";
import BGMobile from "../../../img/svg/home/about-2/bg-mobile.svg";
import OkIcon from "../../../img/svg/home/about-2/ok.svg";
import YesIcon from "../../../img/svg/home/about-2/yes.svg";
import SunIcon from "../../../img/svg/home/about-2/sun.svg";
import AppImg from "../../../img/png/home/about-2/mobile.png";
import { desktop, laptop, tablet } from "../../../styles/breakpoints";
import { useI18n } from "../../../i18n";

const About = () => {
  const { t } = useI18n();
  return (
  <div style={{ position: "relative", background: "#F6F4F2", overflow: 'hidden' }}>
    <div className={style.bg}>
      <div className="wrapper">
        <img src={SunIcon} className="sun" alt={t("about_alt_sun")} />
        <img src={OkIcon} className="ok" alt="ok" />
        <img src={YesIcon} className="yes" alt="yes" />
        <img src={AppImg} className="app" alt="app" />
      </div>
    </div>
    <div className={style.container}>
      <div className="wrapper">
        <div className="heading">
          <h2>
            {t("home_about_meet")}
            <br />
            <span>
              {t("home_about_zilouet")}
            </span>
          </h2>
        </div>
        <div className="text">
          <h5>
            {t("home_about_desc1")}
            <br />
            {t("home_about_desc2")}
            <br />
            {t("home_about_desc3")}
          </h5>
          <div>
            <p>
              {t("home_about_desc4")}
              <br />
              <br />
              {t("home_about_rhyme")}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

const style = {
  bg: css({
    backgroundRepeat: "no-repeat",
    backgroundPosition: "56%",
    backgroundSize: "cover",
    backgroundImage: `url(${BG})`,
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "flex-start",
    alignItems: "center",

    ".wrapper": {
      maxWidth: 1000,
      width: "100%",
      position: "relative",
    },
    img: {
      position: "absolute",
    },

    ".ok": {
      top: 62,
      left: "48%",
    },
    ".yes": {
      top: 255,
      left: "70%",
    },
    ".sun": {
      top: 174,
      left: "-8%",
    },
    ".app": {
      top: 31,
      left: 0,
      maxWidth: 610,
    },

    [desktop]: {
      ".ok": {
        top: 82,
        left: "40%",
        width: 348.184,
        height: 246.177,
      },
      ".yes": {
        top: 245,
        left: "62%",
        width: 210,
        height: 210,
      },
      ".sun": {
        top: 184,
        left: "0",
        width: 140,
        height: 140,
      },
      ".app": {
        top: 80,
        left: '5%',
        width: 491.859,
        height: 790.372,
      },
    },
    [laptop]: {
      backgroundImage: `url(${BGMobile})`,
      height: 900,
      ".ok": {
        top: 55,
        left: "59%",
        width: 183.369,
        height: 129.648,
      },
      ".yes": {
        top: 135,
        left: "72%",
        width: 120,
        height: 120,
      },
      ".sun": {
        top: 184,
        left: "20%",
        width: 140,
        height: 140,
      },
      ".app": {
        top: 125,
        left: '8%',
        right: 0,
        width: 430,
        height: 691.51,
        margin: 'auto',
      },
    },
    [tablet]: {
      height: 640,
      ".ok": {
        top: 35,
        left: "59%",
        width: 163.369,
        height: 109.648,
      },
      ".yes": {
        top: 100,
        left: "75%",
        right: 0,
        width: 100,
        height: 100,
      },
      ".sun": {
        top: 184,
        left: "10%",
        width: 100,
        height: 100,
      },
      ".app": {
        top: 89,
        left: '8%',
        right: 0,
        width: 271,
        height: 435.812,
        margin: 'auto',
      },
    },
  }),

  container: css({
    width: "100%",
    display: "flex",
    position: "relative",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",

    ".wrapper": {
      width: 704.127,
      padding: 10,
      marginLeft: "470px",
      marginBottom: "90px",
    },
    ".heading": {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
      marginTop: 534,
      padding: 10,

      h2: {
        color: "#000",
        textAlign: "right",
        fontFamily: "Syne",
        fontSize: 182.235,
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "181.478px",
      },
    },
    ".text": {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
      marginTop: 60,
      padding: 20,
      maxWidth: 660,

      h5: {
        color: "#000",
        textAlign: "center",
        fontFamily: "Syne",
        fontSize: 34.6,
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "normal",
        marginBottom: 16,
      },
      div: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        justifyContent: "center",
        alignItems: "center",
        gap: 30,
        p: {
          color: "#000",
          textAlign: "center",
          fontFamily: "Inter",
          fontSize: 15,
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "normal",
          letterSpacing: 0.13,
          flex: "0 0 50%",
          margin: "0 auto",
        },
      },
    },

    [desktop]: {
      ".wrapper": {
        width: 640,
        marginLeft: "280px",
        marginBottom: "90px",
      },
      ".heading": {
        marginTop: 450,
        padding: 10,

        h2: {
          fontSize: 145,
          lineHeight: "145px",
        },
      },
      ".text": {
        marginTop: 60,
        padding: 20,
        maxWidth: 640,

        h5: {
          fontSize: 32,
        },
        div: {
          p: {
            fontSize: 16,
            flex: "0 0 50%",
          },
        },
      },
    },
    [laptop]: {
      ".wrapper": {
        width: 640,
        marginLeft: 0,
        marginBottom: "90px",
      },
      ".heading": {
        marginTop: 685,
        padding: 10,

        h2: {
          fontSize: 60,
          lineHeight: '91%',

          span: {
            lineHeight: '105%',
            fontSize: 90,
          }
        },
      },
      ".text": {
        marginTop: 0,
        padding: 20,
        maxWidth: 640,

        h5: {
          fontSize: 32,
        },
        div: {
          flexDirection: 'column',
          gap: 10,
          p: {
            fontSize: 21,
            flex: "0 0 100%",
          },
        },
      },
    },
    [tablet]: {
      ".wrapper": {
        width: 640,
        marginLeft: 0,
        marginBottom: "90px",
      },
      ".heading": {
        marginTop: 435,
        padding: 10,

        h2: {
          fontSize: 38,
          lineHeight: '91%',

          span: {
            lineHeight: '105%',
            fontSize: 60,
          }
        },
      },
      ".text": {
        marginTop: 0,
        padding: 20,
        maxWidth: 305,
        margin: 'auto',

        h5: {
          fontSize: 25,
        },
        div: {
          flexDirection: 'column',
          gap: 10,
          p: {
            fontSize: 16,
            flex: "0 0 100%",
          },
        },
      },
    },
  }),
};

export default About;
